import { AssessmentAPI, AssessmentTypeAPI, ScoringPolicyAPI } from '@oneapp/main/core/assessment/assessment.models';
import { GameModelAPI } from '@oneapp/main/core/game/game.models';
import { StateSliceDefaults, StateSliceName } from '@oneapp/main/core/store.models';

export enum AssessmentLibraryTableColumn {
    INFO = 'info',
    ORIGINAL_GAME_ID = 'originalGameId',
    GAME_ID = 'gameId',
    POLICY = 'policy',
    TYPE = 'type',
    COMPLETION_TIME = 'completionTime',
    DATE_GENERATED = 'date',
    CALL_TO_ACTION = 'cta'
}

export interface AssessmentLibraryTableRow {
    [AssessmentLibraryTableColumn.INFO]: {
        id: string;
        name: string;
        description: string;
    };
    [AssessmentLibraryTableColumn.ORIGINAL_GAME_ID]: {
        id: string;
        class: string;
    };
    [AssessmentLibraryTableColumn.GAME_ID]: {
        id: string;
        class: string;
    };
    [AssessmentLibraryTableColumn.POLICY]: ScoringPolicyAPI;
    [AssessmentLibraryTableColumn.TYPE]: AssessmentTypeAPI;
    [AssessmentLibraryTableColumn.COMPLETION_TIME]: string;
    [AssessmentLibraryTableColumn.DATE_GENERATED]: string;
    [AssessmentLibraryTableColumn.CALL_TO_ACTION]: string;
}

export enum AssessmentLibraryFormControlName {
    STRING_FILTER = 'stringFilter',
    POLICY = 'policy',
    TYPE = 'type'
}

export interface AssessmentLibraryFilterValues {
    [AssessmentLibraryFormControlName.STRING_FILTER]?: string;
    [AssessmentLibraryFormControlName.POLICY]?: string;
    [AssessmentLibraryFormControlName.TYPE]?: string;
}

export const FORM_DEFAULT_VALUE = 'default';
export const DEFAULT_NUMBER_ENTRIES = 10;

export interface AssessmentLibraryStateModel {
    formValues: AssessmentLibraryFilterValues;
    assessments: AssessmentAPI[];
    gamesForAssessments: GameModelAPI[];
}

export const assessmentLibraryStateDefaults: StateSliceDefaults<AssessmentLibraryStateModel> = Object.freeze({
    sliceName: StateSliceName.ASSESSMENT_LIBRARY,
    defaults: {
        formValues: {
            [AssessmentLibraryFormControlName.STRING_FILTER]: '',
            [AssessmentLibraryFormControlName.POLICY]: FORM_DEFAULT_VALUE,
            [AssessmentLibraryFormControlName.TYPE]: FORM_DEFAULT_VALUE
        },
        assessments: undefined,
        gamesForAssessments: []
    }
});
